module.exports = require('./helpers/bundle-url').getBundleURL('a7p0b') + "tessellation-worker.86c97502.js";